import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from "@mui/material";
import Map, { Marker } from 'react-map-gl/mapbox';
import "mapbox-gl/dist/mapbox-gl.css";
import axios from 'axios';

export default function ContactForm({ imageUrl, setImageUrl }) {
    const [formItems, setFormItems] = useState({
        product: "Pergola",
        first_name: "",
        last_name: "",
        phone_number: "",
        email_address: "",
        address: "",
        message: "",
        captcha: "",
    });
    const [open, setOpen] = useState(false);

    // Google Places Autocomplete state
    const [value, setValue] = useState(null);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        if (imageUrl) {
            setFormItems((prev) => ({ ...prev, product: "reference-image" }));
        }
    }, [imageUrl]);

    const handleInputChange = (item) => (event) => {
        setFormItems((prev) => ({ ...prev, [item]: event.target.value }));
    };

    const gtag_report_conversion = (url) => {
        const callback = function () {
            if (typeof url !== "undefined") {
                window.location = url;
            }
        };
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag("event", "conversion", {
                send_to: "AW-17331600370/S3ZFCJiFne0aEPL3rMhA",
                event_callback: callback,
            });
        } else {
            callback();
        }
        return false;
    };

    const sendGtagEvent = (callback) => {
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag("event", "form_submit_action", {
                event_callback: callback,
                event_timeout: 2000,
            });
        } else {
            console.warn("gtag function not available");
            callback();
        }
    };

    const handleButtonClick = async () => {
        sendGtagEvent(async () => {
            const payload = {
                ...formItems
            };
            if (payload.product === "reference-image" && imageUrl) {
                payload.image = imageUrl;
            }

            try {
                const response = await axios.post(
                    "https://api-dot-wrightglazing.nw.r.appspot.com/api/contact_form",
                    { data: payload }
                );
                console.log("Response:", response.data);
                setOpen(true);
                // gtag_report_conversion();

                // reset
                setFormItems({
                    product: "Pergola",
                    first_name: "",
                    last_name: "",
                    phone_number: "",
                    email_address: "",
                    address: "",
                    message: "",
                    captcha: "",
                });
                setValue("");
                if (setImageUrl) setImageUrl(undefined);
            } catch (error) {
                console.error("Error:", error);
            }
        });
    };

    const handleClose = () => setOpen(false);

    return (
        <React.Fragment>
            <Box
                sx={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    bgcolor: 'rgb(255, 255, 255)',
                    p: 2,
                }}

                id="contact-form"
            >
                <Grid container sx={{ display: 'flex', flex: 1 }}>
                    <Grid item size={{md: 6, xs: 12}} p={{md: 2, xs: 1}}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: {md: 4, xs: 2},
                                borderRadius: 3, overflow: "hidden",
                                width: "100%",
                                height: '100%',
                                color: 'white',
                                "& .MuiInputBase-input": {     // input text
                                    color: "white",
                                },
                                "& .MuiInputLabel-root": {     // label color
                                    color: "white",
                                },
                                "& .MuiOutlinedInput-notchedOutline": { // input border
                                    borderColor: "white",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": { // border on hover
                                    borderColor: "white",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": { // border when focused
                                    borderColor: "white",
                                },
                            }}
                        >
                            <Typography variant="h4" gutterBottom textAlign="center">
                                GET A FREE QUOTE
                            </Typography>
                            <Typography variant="h6" gutterBottom textAlign="center" mb={2}>
                                Up to £250 off when you get a free no-obligation quote.
                            </Typography>
                            <Stack spacing={2} sx={{}}>
                                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                    <TextField label="First Name" name="firstName" value={formItems.first_name} onChange={handleInputChange("first_name")} fullWidth required />
                                    <TextField label="Last Name" name="lastName" value={formItems.last_name} onChange={handleInputChange("last_name")} fullWidth required />
                                </Stack>

                                <TextField label="Phone" name="phone" value={formItems.phone_number} onChange={handleInputChange("phone_number")} fullWidth required />
                                <TextField label="Email" name="email" type="email" value={formItems.email_address} onChange={handleInputChange("email_address")} fullWidth required />
                                <TextField
                                    label="Address"
                                    name="address"
                                    fullWidth
                                    multiline
                                    rows={3}
                                    required
                                    value={formItems.address}
                                    onChange={handleInputChange("address")}
                                />
                                <TextField label="Message" name="message" fullWidth required multiline rows={5} value={formItems.message} onChange={handleInputChange("message")} />
                                <Button variant="contained" color="primary" size="large" onClick={handleButtonClick}>
                                    Submit
                                </Button>
                            </Stack>
                        </Paper>
                    </Grid>

                    <Grid item size={{md: 6, xs: 12}} p={{md: 2, xs: 1}}>
                        {/* UNDERNEATH: Mapbox map (react-map-gl) */}
                        <Paper elevation={3} sx={{ p: {md: 4, xs: 2}, borderRadius: 3, overflow: "hidden", height: '100%' }}>
                            <Map
                                mapboxAccessToken="pk.eyJ1IjoibG91aXN3cmlnaHQxMyIsImEiOiJjbHQzOTlhb3MxaDdrMmtvZXhlajUxYm14In0.UzbKfRCmqGWErSkjKuEMmg"
                                initialViewState={{
                                    longitude: -0.218000,
                                    latitude: 51.367810,
                                    zoom: 13,
                                }}
                                mapStyle="mapbox://styles/louiswright13/clt39btnl00aj01p810hjfm6y"
                                style={{ height: "45vh", width: "100%" }}
                            >
                                <Marker longitude={-0.218000} latitude={51.367810} color="blue" />
                            </Map>

                            <Box sx={{ p: 2, color: 'white' }}>
                                <Typography fontWeight={600}>Our Location</Typography>
                                <Typography variant="body2">
                                    94-96 Priory Road <br />
                                    Cheam <br />
                                    Surrey <br />
                                    SM3 8LN
                                </Typography>
                            </Box>
                        </Paper>
                    </Grid>

                </Grid>

            </Box>

            {/* Success Dialog */}
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Success</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please allow up to 48 hours for a response.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
